import React, { forwardRef } from 'react';
import classNames from 'classnames';

import styles from './Input.module.scss';

function Input(
  { className, ...remainingProps }: IInput,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  return (
    <input
      ref={ref}
      className={classNames(styles.root, className)}
      {...remainingProps}
    />
  );
}

export default forwardRef(Input);
